// extracted by mini-css-extract-plugin
export var dropdownContainer = "_ix-0";
export var leftAlign = "_ix-4";
export var listItem = "_ix-2";
export var listItemWrapper = "_ix-1";
export var operationText = "_ix-3";